import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconEchartBearing = ({ color = colors.black }) => {
    return <svg width='4' height='16' viewBox='0 0 4 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M0 2C0 0.895431 0.895431 0 2 0V0C3.10457 0 4 0.895431 4 2V14C4 15.1046 3.10457 16 2 16V16C0.895431 16 0 15.1046 0 14V2Z' fill={color} />
    </svg>;
};

IconEchartBearing.propTypes = {
    color: PropTypes.string,
};

export default IconEchartBearing;
